import { PropsWithChildren } from 'react'

export const Card: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className='flex flex-col gap-3 bg-white shadow-2xl px-6
      py-4 rounded-lg'
    >
      {children}
    </div>
  )
}
